module.exports = __webpack_public_path__ + "img/Thumbnail_ZWF_Hani_Chang.895c9b9f.jpg";